import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import packageApiController from "../../services/package.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
export const usersAdapter = createEntityAdapter();

const packageErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const PackageViewApi = createAsyncThunk("package/packageview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "packageview"))
      .catch((error) => HandleError(thunkAPI, error, "packageview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
export const PackageKeyFeaturesApi = createAsyncThunk("package/keyfeatures", async (formValues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .packagekeyfeatures(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "keyfeatures"))
      .catch((error) => HandleError(thunkAPI, error, "keyfeatures"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const PackageFeatureViewApi = createAsyncThunk("package/packagefeatureview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .packagefeatureview(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "packagefeatureview"))
      .catch((error) => HandleError(thunkAPI, error, "packagefeatureview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const PackageStoreApi = createAsyncThunk("package/create", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .create(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "create"))
      .catch((error) => HandleError(thunkAPI, error, "create"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const PackagePaymentApi = createAsyncThunk("package/payment", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .packagepayment(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "payment"))
      .catch((error) => HandleError(thunkAPI, error, "payment"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const PackagePaymentFailedApi = createAsyncThunk("package/paymentdfailed", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .packagepaymentfailed(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "paymentdfailed"))
      .catch((error) => HandleError(thunkAPI, error, "paymentdfailed"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const PackageCreatePaymentIntentApi = createAsyncThunk("package/createPaymentIntent", async (formValues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .createPaymentIntent(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "createPaymentIntent"))
      .catch((error) => HandleError(thunkAPI, error, "createPaymentIntent"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const PlanCancelApi = createAsyncThunk("package/plancancel", async (formValues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .plancancel(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "plancancel"))
      .catch((error) => HandleError(thunkAPI, error, "plancancel"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
export const DefaultCardRemoveApi = createAsyncThunk("package/cardremove", async (formValues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .cardremove(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "cardremove"))
      .catch((error) => HandleError(thunkAPI, error, "cardremove"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
export const PackageInvoiceApi = createAsyncThunk("package/invoice", async (formValues, thunkAPI) => {
  try {
    const resposedata = await packageApiController
      .packageinvoice(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "invoice"))
      .catch((error) => HandleError(thunkAPI, error, "invoice"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
const initialState = {
  isOpenSelectedPackage: "",
  isOpenMainPackage: "",
  isPackageView: [],
  isPackageViewError: "",
  isPackageFeatureView: [],
  isPackageFeatureViewError: "",
  isPackageManageData: "",
  isPackageName: "",
  isPackageCreatePaymentIntentApi: "",
  isPackageCreatePaymentIntentError: "",
  isPackagePaymentApi: "",
  isPackagePaymentError: "",
  isPackagePaymentFailedApi: "",
  isPackagePaymentFailedError: "",
  isPackageStoreApi: "",
  isPackageStoreError: "",
  isstaffUpgradePackageTexts: { isstaffTitleTexts: "", isstaffdescriptionTexts: "" },
  isFreeTrialUpgradePackageTexts: { isfreeTrialTitleTexts: "", isfreeTrialdescriptionTexts: "" },
  isPackageModal: "",
  isPlanCancel: "",
  isPlanCancelError: "",
  isMaxStaffAlert: "",
  isDefaultRemove: "",
  isDefaultRemoveError: "",
  isPackageKeyFeaturesList: [],
  isPackageKeyFeaturesError: "",
  isPackageInvoice: [],
  isPackageInvoiceError: "",
  isApiStatus: {
    PackageViewApi: "",
    PackageFeatureViewApi: "",
    PackageCreatePaymentIntentApi: "",
    PackagePaymentApi: "",
    PackagePaymentFailedApi: "",
    PlanCancelApi: "",
    DefaultCardRemoveApi: "",
    PackageKeyFeaturesApi: "",
    PackageInvoiceApi: "",
  },
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    reset: () => initialState,
    OpenSelectedPackage: (state, action) => {
      state.isOpenSelectedPackage = action.payload;
    },
    OpenMainPackage: (state, action) => {
      state.isOpenMainPackage = action.payload;
    },
    PackagePaymentsData: (state, action) => {
      state.isPackageManageData = action.payload;
    },
    PackagePaymentsDataName: (state, action) => {
      state.isPackageName = action.payload;
    },
    PackagePaymentModal: (state, action) => {
      state.isPackageModal = action.payload;
    },
    MaxStaffAlert: (state, action) => {
      state.isMaxStaffAlert = action.payload;
    },
    StaffUpgradePackageTexts: (state, action) => {
      state.isstaffUpgradePackageTexts = { ...state.isstaffUpgradePackageTexts, ...action.payload };
    },
    FreeTrialUpgradePackageTexts: (state, action) => {
      state.isFreeTrialUpgradePackageTexts = { ...state.isFreeTrialUpgradePackageTexts, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PackageViewApi.pending, (state) => {
        state.isPackageViewError = "";
        state.isApiStatus = { ...state.isApiStatus, PackageViewApi: "loading" };
      })
      .addCase(PackageViewApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageViewApi: "succeeded" };
        state.isPackageView = action.payload;
        state.isPackageViewError = "";
      })
      .addCase(PackageViewApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageViewApi: "failed" };
        state.isPackageViewError = packageErrorMessage(action, "Unable to load packages.");
      })
      .addCase(PackageKeyFeaturesApi.pending, (state) => {
        state.isPackageKeyFeaturesError = "";
        state.isApiStatus = { ...state.isApiStatus, PackageKeyFeaturesApi: "loading" };
      })
      .addCase(PackageKeyFeaturesApi.fulfilled, (state, action) => {
        state.isPackageKeyFeaturesList = action.payload;
        state.isPackageKeyFeaturesError = "";
        state.isApiStatus = { ...state.isApiStatus, PackageKeyFeaturesApi: "succeeded" };
      })
      .addCase(PackageKeyFeaturesApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageKeyFeaturesApi: "failed" };
        state.isPackageKeyFeaturesError = packageErrorMessage(action, "Unable to load package features.");
      })
      .addCase(PackageFeatureViewApi.pending, (state) => {
        state.isPackageFeatureViewError = "";
        state.isApiStatus = { ...state.isApiStatus, PackageFeatureViewApi: "loading" };
      })
      .addCase(PackageFeatureViewApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageFeatureViewApi: "succeeded" };
        state.isPackageFeatureView = action.payload;
        state.isPackageFeatureViewError = "";
      })
      .addCase(PackageFeatureViewApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageFeatureViewApi: "failed" };
        state.isPackageFeatureViewError = packageErrorMessage(action, "Unable to load package feature details.");
      })
      .addCase(PackageStoreApi.pending, (state) => {
        state.isPackageStoreError = "";
        state.isApiStatus = { ...state.isApiStatus, PackageStoreApi: "loading" };
      })
      .addCase(PackageStoreApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageStoreApi: "succeeded" };
        state.isPackageStoreApi = action.payload;
        state.isPackageStoreError = "";
      })
      .addCase(PackageStoreApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageStoreApi: "failed" };
        state.isPackageStoreError = packageErrorMessage(action, "Unable to create the package purchase.");
      })
      .addCase(PackageCreatePaymentIntentApi.pending, (state) => {
        state.isPackageCreatePaymentIntentError = "";
        state.isApiStatus = { ...state.isApiStatus, PackageCreatePaymentIntentApi: "loading" };
      })
      .addCase(PackageCreatePaymentIntentApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageCreatePaymentIntentApi: "succeeded" };
        state.isPackageCreatePaymentIntentApi = action.payload;
        state.isPackageCreatePaymentIntentError = "";
      })
      .addCase(PackageCreatePaymentIntentApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageCreatePaymentIntentApi: "failed" };
        state.isPackageCreatePaymentIntentError = packageErrorMessage(action, "Unable to create the package payment intent.");
      })
      .addCase(PackagePaymentApi.pending, (state) => {
        state.isPackagePaymentError = "";
        state.isApiStatus = { ...state.isApiStatus, PackagePaymentApi: "loading" };
      })
      .addCase(PackagePaymentApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackagePaymentApi: "succeeded" };
        state.isPackagePaymentApi = action.payload;
        state.isPackagePaymentError = "";
      })
      .addCase(PackagePaymentApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackagePaymentApi: "failed" };
        state.isPackagePaymentError = packageErrorMessage(action, "Unable to complete package payment.");
      })
      .addCase(PackagePaymentFailedApi.pending, (state) => {
        state.isPackagePaymentFailedError = "";
        state.isApiStatus = { ...state.isApiStatus, PackagePaymentFailedApi: "loading" };
      })
      .addCase(PackagePaymentFailedApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackagePaymentFailedApi: "succeeded" };
        state.isPackagePaymentFailedApi = action.payload;
        state.isPackagePaymentFailedError = "";
      })
      .addCase(PackagePaymentFailedApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackagePaymentFailedApi: "failed" };
        state.isPackagePaymentFailedError = packageErrorMessage(action, "Unable to record the failed package payment.");
      })
      .addCase(PlanCancelApi.pending, (state) => {
        state.isPlanCancelError = "";
        state.isApiStatus = { ...state.isApiStatus, PlanCancelApi: "loading" };
      })
      .addCase(PlanCancelApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PlanCancelApi: "succeeded" };
        state.isPlanCancel = action.payload;
        state.isPlanCancelError = "";
      })
      .addCase(PlanCancelApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PlanCancelApi: "failed" };
        state.isPlanCancelError = packageErrorMessage(action, "Unable to cancel the package plan.");
      })
      .addCase(DefaultCardRemoveApi.pending, (state) => {
        state.isDefaultRemoveError = "";
        state.isApiStatus = { ...state.isApiStatus, DefaultCardRemoveApi: "loading" };
      })
      .addCase(DefaultCardRemoveApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, DefaultCardRemoveApi: "succeeded" };
        state.isDefaultRemove = action.payload;
        state.isDefaultRemoveError = "";
      })
      .addCase(DefaultCardRemoveApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, DefaultCardRemoveApi: "failed" };
        state.isDefaultRemoveError = packageErrorMessage(action, "Unable to remove the default card.");
      })
      .addCase(PackageInvoiceApi.pending, (state) => {
        state.isPackageInvoiceError = "";
        state.isApiStatus = { ...state.isApiStatus, PackageInvoiceApi: "loading" };
      })
      .addCase(PackageInvoiceApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageInvoiceApi: "succeeded" };
        state.isPackageInvoice = action.payload;
        state.isPackageInvoiceError = "";
      })
      .addCase(PackageInvoiceApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, PackageInvoiceApi: "failed" };
        state.isPackageInvoiceError = packageErrorMessage(action, "Unable to load package invoices.");
      });
  },
});

export const { reset, OpenSelectedPackage, OpenMainPackage, PackagePaymentsData, PackagePaymentsDataName, PackagePaymentModal, FreeTrialUpgradePackageTexts, StaffUpgradePackageTexts, MaxStaffAlert } = packageSlice.actions;
export default packageSlice.reducer;
